import type { PatchNote } from "../lib/patchNotes";

// Shared between the one-time "what's new" overlay (unseen entries only)
// and the full version history under Konto (every entry) — same rendering,
// different slice of PATCH_NOTES passed in.
export function PatchNoteList({ notes }: { notes: PatchNote[] }) {
  return (
    <div className="space-y-5">
      {notes.map((n) => (
        <div key={n.version}>
          <p className="text-xs font-medium uppercase tracking-wider text-ink-400 dark:text-night-faint">{n.date}</p>
          <p className="mt-0.5 font-display text-lg font-semibold text-plum-900 dark:text-night-accent">{n.title}</p>
          <ul className="mt-2 space-y-1.5">
            {n.items.map((item, i) => (
              <li key={i} className="flex gap-2 text-sm text-ink-600 dark:text-night-muted">
                <span className="flex-shrink-0 text-plum-600 dark:text-night-accent">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
